{{procesando}}
<div class="contenedor-tabla">
    <mat-table
        class="comunas"
        #table
        [dataSource]="dataSource"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <!-- Type Column -->
        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
            <mat-cell *matCellDef="let comuna">
                {{ comuna.nombre }}
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="recargo">
            <mat-header-cell *matHeaderCellDef>Factor</mat-header-cell>
            <mat-cell *matCellDef="let comuna">
                <input
                    [(ngModel)]="comuna.recargo"
                    matInput
                    type="number"
                    min="0"
                    required
                    (onchange)="cambia($event, comuna)"
                    value="{{ comuna.recargo }}"
                />
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="guardar">
            <mat-header-cell *matHeaderCellDef>Guardar</mat-header-cell>
            <mat-cell *matCellDef="let comuna">
                <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    [disabled]="(comuna.recargo < 0 || comuna.recargo === null) || procesando"
                    (click)="guardar(comuna)"
                >
                    <mat-icon>save</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let comuna; columns: displayedColumns"> </mat-row>
    </mat-table>
</div>

<!-- table class="simple mt-8">
    <thead>
        <tr>
            <th>Nombre</th>
            <th>Recargo</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let comuna of comunas">
            <td>
                {{ comuna.nombre }}
            </td>
            <td>{{ comuna.recargo }}</td>
        </tr>
    </tbody>
</table -->
